import React from 'react';
import CustomButton from '../Components/Ui/CustomButton';

interface PDFViewerProps {
  base64Pdf: string;
  onClose: () => void;
}

const PDFViewer: React.FC<PDFViewerProps> = ({ base64Pdf, onClose }) => {
  const pdfData = `data:application/pdf;base64,${base64Pdf}`;

  return (
    <div className="h-[100vh] flex flex-col items-center justify-center">
      <div className="w-full max-w-[210mm] h-[297mm] overflow-auto bg-gray-100 p-4 flex justify-center items-start">
        <iframe
          src={pdfData}
          className="w-full h-full border-none shadow-md rounded"
          title="PDF Viewer"
        />
      </div>
      <CustomButton theme="navy" className="w-[150px] h-[40px] mt-4" onClick={onClose}>
        Schliessen
      </CustomButton>
    </div>
  );
};

export default PDFViewer;
